export const authResponseProps = {
    status: false,
    admin: false,
    access_token: '',
    company: {
        name: '', email: ''
    },
    expiration_time: null,
    days_left: 0,
    locale_info: {
        country_code: '',
        calling_code: '',
        currency_code: '',
        max_fraction: 2,
        thousand_separator: ',',
        decimal_separator: '.'
    },
    accessible_branches: [],
    modules: []
}

export let menuProperties = {
    menus: [
        {
            index: 0,
            parentName: 'Configurar',
            icon: 'power',
            access: {showSubMenu: false, canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true},
            subMenus: [ //company profile shud include 3 tabs: company, branches, loyalty point settings, holidays
                {index: 0, menu: 'Dashboard', path: '/dashboard', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},
                {index: 1, menu: 'Organización', path: '/organisation', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},
                {index: 2, menu: 'Especialidades de empleados', path: '/designations', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},
                {index: 3, menu: 'Empleados', path: '/employees', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},
                {index: 4, menu: 'Proveedores', path: '/suppliers', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},
                {index: 5, menu: 'Usuarios', path: '/users', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},
            ]
        },
        {
            index: 1,
            parentName: 'Inventario y Servicios',
            icon: 'assignment',
            access: {showSubMenu: false, canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true},
            subMenus: [
                {index: 0, menu: 'Productos de inventario', path: '/inventoryproducts', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},
                {index: 3, menu: 'Solicitudes de compra', path: '/purchaseorders', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},
                {index: 4, menu: 'Facturas de compra', path: '/purchaseinvoices', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},
                {index: 3, menu: 'Lista de servicios', path: '/servicelist', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},
                
            ]
        },
        {
            index: 2,
            parentName: 'Salones y Menú',
            icon: 'attach_money',
            access: {showSubMenu: false, canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true},
            subMenus: [
                {index: 1, menu: 'Salones', path: '/halls', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},//invoices will have two tabs: 1. production calendar, 2. invoice list
                {index: 2, menu: 'Menú de Catering', path: '/foodmenus', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},
            ]
        },
        {
            index: 3,
            parentName: 'Ventas',
            icon: 'ballot',
            access: {showSubMenu: false, canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true},
            subMenus: [
                {index: 0, menu: 'Presupuestos', path: '/enquiries', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},
                {index: 0, menu: 'Eventos', path: '/events', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},
            ]
        },/*
        {
            index: 3,
            parentName: 'Ventas externas',
            icon: 'ballot',
            access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true},
            subMenus: [
                {index: 0, menu: 'Presupuestos', path: '/workorders', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},
                {index: 0, menu: 'Events', path: '/selfentryproduction', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},
            ]
        },
        {
            index: 8,
            parentName: 'Tools',
            icon: 'settings_applications',
            access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true},
            subMenus: [
                {index: 0, menu: 'Calendar', path: '/attendancesetup', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},                
                {index: 1, menu: 'Tasks', path: '/attendanceentry', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},//invoices will have two tabs: 1. production calendar, 2. invoice list
                {index: 2, menu: 'Contacts', path: '/singleentries', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},
            ]
        },*/
        {
            index: 5,
            parentName: 'Cuentas',
            icon: 'account_balance_wallet',
            access: {showSubMenu: false, canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true},
            subMenus: [
                {index: 0, menu: 'Transacciones', path: '/singleentries', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},
            ]
        },
        {
            index: 6,
            parentName: 'Informes',
            icon: 'bar_chart',
            access: {showSubMenu: false, canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true},
            subMenus: [
               // {index: 0, menu: 'Inventario', path: '/inventoryreports', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},                
                {index: 2, menu: 'Ventas', path: '/salesreports', access: {canView: true, canCreate: true, canEdit: true, canDelete: true, adminPermitRequired: true, selfAuthRequired: true, hideCriticalData: true}},
            ]
        }
    ]

}//ecomreports


// WEBPACK FOOTER //
// ./src/store/modules/auth/properties.js